import useSelector from './useSelector';

export default function useExperiments() {
  return useSelector(state => state.experiments);
}
